$(document).ready(function() {
    $("#bannerslider").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 5000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        navText: ["<span><i class='fa fa-angle-right'></i></span>", "<span><i class='fa fa-angle-left'></i></span>"]
    });



    $("#bottomSlider").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1000: {
                items: 1,
                nav: false,
                loop: true
                
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]



    });

	
	
	 $("#offerSlider1").owlCarousel({
        items: 3,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 2,
                nav: true,
                margin: 10
            },
            600: {
                items: 3,
                nav: false,
                margin: 10
            },


            1000: {
                items: 4,
                nav: false,
                loop: true,
                margin: 20
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]



    });
	
	
	
	
	
	
 $("#team-slid").owlCarousel({
        items: 6,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1000: {
                items: 1,
                nav: false,
                loop: true,
                margin: 30
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'</i></span>"]



    });
    $("#team-slid1").owlCarousel({
        items: 4,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1000: {
                items: 1,
                nav: false,
                loop: true,
                margin: 30
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'</i></span>"]



    });



	 $("#related-slid").owlCarousel({
        items: 4,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 4,
                nav: true
            },
            600: {
                items: 2,
                nav: false
            },


            1000: {
                items: 4,
                nav: false,
                loop: true,
                margin: 10
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]



    });






});







$(document).ready(function() {
    $(window).scroll(function() {
        if ($(this).scrollTop() > 200) {
            $('.up').fadeIn(400);
        } else { $('.up').fadeOut(400); }
    });

    $('.up').click(function(event) {
        event.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 800);
    });

});





jQuery(window).scroll(function() {
    var scroll = jQuery(window).scrollTop();
    if (scroll >= 100) {
        jQuery('header').addClass('fixed-nav');
    } else {
        jQuery('header').removeClass('fixed-nav');
    }
});

function topFunction() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

 